// Lazy facade over `@/lib/analytics`. Importing this module does not pull
// the analytics module (or mixpanel-browser) into the importer's chunk; the
// underlying module is fetched on first call and cached by the bundler.

export function track(event: string, properties?: Record<string, unknown>): void {
  void import("@/lib/analytics").then((m) => m.track(event, properties));
}
